import React, { useMemo, useCallback } from 'react';
import propTypes from 'prop-types';
import { NavLink, Link } from 'react-router-dom';
;
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { UiTable, UiTooltip, stripHtml } from 'src/ui';
import { Button, MuiDropdown, MuiDropdownItem } from 'src/ui/mui-ui-kit';;
import { TableDate } from 'src/people';
import { VendorStatus } from './VendorStatus';


export function VendorsTable({
  loading,
  vendors,
  onArchive,
  onUpdate,
  isAllVendors,
  paging,
}) {
  const onClickArchive = useCallback(vendor => () => onArchive(vendor), []);

  const renderLink = (row, className) => (
    <Link
      className={className}
      to={
        isAllVendors
          ? `/all-vendors/edit/${row.original.id}`
          : `/vendors/edit/${row.original.id}`
      }
    >
      {row.value}
    </Link>
  );

  const tableColumns = useMemo(() => {
    const columns = [
      {
        Header: 'Vendor Name',
        accessor: 'businessName',
        Cell: row => {
          let text;
          if (!row.original.isApproved) {
            if (row.original.isDenied) {
              text = (
                <span className="has-text-danger">
                  {renderLink(row, 'edit-link')}
                  <UiTooltip
                    content="This vendor has been declined by the bank and can't be attached to your account"
                    icon={['fal', 'exclamation-circle']}
                  />
                </span>
              );
            } else {
              text = (
                <span className="has-text-grey-medium-dark">
                  {renderLink(row, 'has-text-grey-medium-dark')}
                  <UiTooltip
                    content="This vendor is pending verification from the bank"
                    icon={['fal', 'clock']}
                  />
                </span>
              );
            }
          } else {
            text = renderLink(row, 'edit-link');
          }

          return (
            <div className="vendor-name">
              <VendorStatus
                isApproved={row.original.isApproved}
                isDenied={row.original.isDenied}
              />
              {text}
            </div>
          );
        },
      },
      {
        Header: 'Vendor Type',
        accessor: 'businessEntityTypeName',
      },
      {
        Header: '',
        accessor: 'id',
        sortable: false,
        width: 62,
        resizable: false,
        Cell: row => (
          <MuiDropdown
            isAlign="right"
            renderTrigger={
              <Button isColor="white">
                <span className="icon">
                  <FontAwesomeIcon
                    icon={['fal', 'ellipsis-v']}
                    className="has-text-grey"
                    size="lg"
                  />
                </span>
              </Button>
            }
          >
              <MuiDropdownItem
                tag={NavLink}
                to={
                  isAllVendors
                    ? `/all-vendors/edit/${row.value}`
                    : `/vendors/edit/${row.value}`
                }
              >
                Edit Vendor
              </MuiDropdownItem>
              {onUpdate !== null && (
                <>
                  <MuiDropdownItem
                    tag="a"
                    onClick={() =>
                      onUpdate({
                        ...row.original,
                        isApproved: true,
                        isDenied: false,
                      })
                    }
                  >
                    Approve Vendor
                  </MuiDropdownItem>
                  <MuiDropdownItem
                    tag="a"
                    onClick={() =>
                      onUpdate({
                        ...row.original,
                        isApproved: false,
                        isDenied: true,
                      })
                    }
                  >
                    Deny Vendor
                  </MuiDropdownItem>
                </>
              )}
              <MuiDropdownItem
                tag="a"
                onClick={onClickArchive(row.original)}
              >
                Archive Vendor
              </MuiDropdownItem>
          </MuiDropdown>
        ),
      },
    ];

    if (!isAllVendors) {
      columns.splice(1, 0, {
        Header: 'Added at',
        accessor: 'addedAt',
        Cell: row => <TableDate value={row.value} />,
      });
    }

    return columns;
  }, []);

  return (
    <UiTable
      columns={tableColumns}
      loading={loading}
      data={vendors}
      resolveData={data =>
        data.map(vendor => ({
          ...vendor,
          goodsAndServicesProvided: stripHtml(vendor.goodsAndServicesProvided),
        }))
      }
      title="Vendor"
      emptyTo={isAllVendors ? '/all-vendors/add' : '/vendors/add'}
      getTheadThProps={() => ({
        className: 'has-text-left',
      })}
      toNext="/products"
      toPrev="/people"
      // hideNext={isAllVendors}
      // hidePrev={isAllVendors}
      hideNext
      hidePrev
      paging={paging}
    />
  );
}

VendorsTable.defaultProps = {
  onUpdate: null,
  isAllVendors: false,
  paging: undefined,
};

VendorsTable.propTypes = {
  loading: propTypes.bool.isRequired,
  vendors: propTypes.arrayOf(propTypes.object).isRequired,
  onArchive: propTypes.func.isRequired,
  onUpdate: propTypes.func,
  isAllVendors: propTypes.bool,
  paging: propTypes.object,
};
